var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"rounded":"lg"}},[_c('v-card-title',[_vm._v(" Dashboard ")]),_c('v-card-text',[_c('div',{staticClass:"d-flex"},[_c('v-btn',{attrs:{"color":"primary","outlined":"","rounded":""},on:{"click":_vm.logout}},[_vm._v(" Logout ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }